import React, { useState, useEffect, useMemo } from 'react';
import Switch, {
  Size as SwitchSize,
} from '../../../../../../../../../../shared/design-system/components/atoms/switch';
import Select from '../../../../../../../../../../shared/design-system/components/select';
import { Placement } from '../../../../../../../../../../shared/design-system/components/overlay';
import Button from '../../../../../../../../../../shared/design-system/ui/button';
import SettingsText from '../settings-text';
import { TRANSCRIPTION_LANGUAGES, DEFAULT_TRANSCRIPTION_LANGUAGE } from '../../../../../../../../constants/transcription-languages';

export interface ICallRecordingSettingsProps {
  isCallRecordingEnabled: boolean;
  transcriptionLanguage: string;
  onSave: (enabled: boolean, language: string) => void;
  isLoading?: boolean;
}

const CallRecordingSettings: React.FC<ICallRecordingSettingsProps> = ({
  isCallRecordingEnabled: initialIsCallRecordingEnabled,
  transcriptionLanguage: initialTranscriptionLanguage,
  onSave,
  isLoading = false,
}) => {
  const [isCallRecordingEnabled, setIsCallRecordingEnabled] = useState(
    initialIsCallRecordingEnabled,
  );
  const [transcriptionLanguage, setTranscriptionLanguage] = useState(
    initialTranscriptionLanguage,
  );

  useEffect(() => {
    setIsCallRecordingEnabled(initialIsCallRecordingEnabled);
  }, [initialIsCallRecordingEnabled]);

  useEffect(() => {
    setTranscriptionLanguage(initialTranscriptionLanguage);
  }, [initialTranscriptionLanguage]);

  const languageOptions = useMemo(() => TRANSCRIPTION_LANGUAGES, []);

  const handleSave = () => {
    onSave(isCallRecordingEnabled, transcriptionLanguage);
  };

  return (
    <div
      id="call-recording"
      className="settings-wrapper call-recording-settings"
    >
      <SettingsText title="Call Recording & Transcription" />
      <div className="enable-call-recording">
        <Switch
          checked={isCallRecordingEnabled}
          onChange={(checked) => {
            setIsCallRecordingEnabled(checked);
            onSave(checked, DEFAULT_TRANSCRIPTION_LANGUAGE);
          }}
          size={SwitchSize.Small}
          disabled={isLoading}
        />
        <span className="enable-call-recording-label">
          Automatically records all incoming and outgoing calls for this number.
        </span>
      </div>
      {false && <><div className="call-recording-settings__transcription-language">
        <p className="call-recording-settings__transcription-language-title semibold-2 gray-txt-9">
          Transcription Language
        </p>
        <p className="call-recording-settings__transcription-language-desc regular-1 gray-txt-11">
          Select the language for automatic call transcription.
        </p>
        <div className="assign-phone-number-settings__select-container">
          <Select<{ key: string; value: string }>
            className="assign-phone-number-settings__select"
            options={languageOptions}
            selectedOptionKey={transcriptionLanguage}
            selectedOptionRenderer={([option]) => (
              <span>{option?.value || 'Select Language'}</span>
            )}
            optionRenderer={(option) => <span>{option?.value}</span>}
            onChange={([option]) => {
              if (option) {
                setTranscriptionLanguage(option.key);
              }
            }}
            placeholder="Select Language"
            placement={Placement.Top}
          />
        </div>
      </div>
      <div className="call-recording-settings__action">
        <Button
          variant="primary"
          onClick={handleSave}
          isLoading={isLoading}
          loadingText="Save"
          className="call-recording-settings__save-button"
        >
          Save
        </Button>
      </div> </>}
    </div>
  );
};

export default CallRecordingSettings;
